// extracted by mini-css-extract-plugin
export var gatsbyFocusWrapper = "FooterMobile-module--gatsby-focus-wrapper--KirUa";
export var ___gatsby = "FooterMobile-module--___gatsby--QMfRv";
export var footerWrapper = "FooterMobile-module--footer-wrapper--2mLjv";
export var title = "FooterMobile-module--title--12dsi";
export var integrate = "FooterMobile-module--integrate--3BZpp";
export var logo = "FooterMobile-module--logo--1Gle3";
export var app = "FooterMobile-module--app--2wAu3";
export var badge = "FooterMobile-module--badge--1DSqS";
export var misc = "FooterMobile-module--misc--1u-io";
export var sns = "FooterMobile-module--sns--3h2vr";
export var vertical = "FooterMobile-module--vertical--3lQv9";